// extracted by mini-css-extract-plugin
export var discard = "_1l-4";
export var muiTooltipTooltip = "_1l-6";
export var notificationBar = "_1l-3";
export var notificationContainer = "_1l-2";
export var saveButtonHoverSlotWrapper = "_1l-5";
export var show = "_1l-1";
export var spacer = "_1l-0";